import {Nullish} from 'shared/web';

export const getYearOfManufacture = (yearOfManufacture: string | Nullish) =>
  yearOfManufacture?.split('-')?.[0];
